import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CoreaiService {

  private baseUrl = environment.nodeEndpoint;
  
  userDetailSignal = signal<any>(null); // Create a signal for user detail

  constructor(private http: HttpClient) { 
    
    
  }





  getPromptFilter(limit = 10) {
    return this.http.get(`${this.baseUrl}prompt-filter?limit=${limit}`)
  }

  

  createPrompt(promptData: any): Observable<any> {
    let userDetail: string = localStorage.getItem('user_detail') || '{}';
    let parseDetail = JSON.parse(userDetail);
    let userEmail = localStorage.getItem('user_email') || "";

    let payload = {
      // "ohr": userOHR,
      "prompt": promptData,
      
      "email_id": userEmail,
      "coe": parseDetail?.u_coe,
      "department": parseDetail?.department?.display_value,
      // "display_yes_no_prompt": "Yes",
      "band": "4.4",
      "pid": parseDetail?.u_pid,
      "cost_code": parseDetail?.u_cost_code,
      "laptop_image": parseDetail?.u_ncee_ibex,
      "region": parseDetail?.time_zone,
      "source": parseDetail?.source
    }
      return this.http.post(`${this.baseUrl}create-prompt`, payload);
  }

  getBotHistory(limit = 10): Observable<any>{
    
    return this.http.get(`${this.baseUrl}bot-history`);
  }

  getWorkBotHistory(limit = 10): Observable<any>{
    
    return this.http.get(`${this.baseUrl}bot-work-history`);
  }

  getUserDetail(): Observable<any> {
      return this.http.get(`${this.baseUrl}user-detail`);
  }

  fetchAndUpdateUserDetail() {
    this.getUserDetail().subscribe((res: any) => {
      if (res?.result?.length > 0) {
        const userDetail = res.result[0] || '';
        localStorage.setItem('user_detail', JSON.stringify(userDetail));
        this.userDetailSignal.set(userDetail); // Update the signal
      }
    });
  }

  getCurrentUserDetailFromLocalStorage() {
    const userDetail = localStorage.getItem('user_detail');
    return userDetail ? JSON.parse(userDetail) : null;
  }

  
  getAccessToken(): Observable<any> {
     return this.http.get(`${this.baseUrl}access-token`);
  }

  
}
